/**
 * CTA Banner Block
 * Call-to-action promotional banner
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const CTABannerBlock = ({ settings = {}, isLoggedIn = false }) => {
  const {
    title = 'Start Creating Today',
    subtitle = 'Join thousands of creators sharing their stories',
    button_text = 'Get Started',
    button_link = '/creator/signup',
    background_gradient = 'from-orange-500 to-red-600',
    show_to_logged_in = false,
  } = settings;

  // Hide for logged-in users if configured
  if (isLoggedIn && !show_to_logged_in) return null;

  return (
    <section 
      className={`my-8 sm:my-12 mx-2 sm:mx-6`}
      data-testid="cta-banner-block"
    >
      <div 
        className={`relative overflow-hidden rounded-2xl bg-gradient-to-r ${background_gradient} p-6 sm:p-10`}
      >
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-40 h-40 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-60 h-60 bg-white rounded-full translate-x-1/4 translate-y-1/4" />
        </div>
        
        <div className="relative flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <div className="flex items-center justify-center sm:justify-start gap-2 mb-2">
              <Megaphone className="w-6 h-6 text-white/90" />
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">
                {title}
              </h3>
            </div>
            <p className="text-white/80 text-sm sm:text-base max-w-md">
              {subtitle}
            </p>
          </div>
          
          <Link to={button_link}>
            <Button 
              size="lg"
              className="bg-white text-orange-600 hover:bg-gray-100 font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200"
            >
              {button_text}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTABannerBlock;
